module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Light.bf6033079bd7eda4a22ca255108af767.eot";